/**
 * Contains the field names which always exist in the system.
 */
export const DefaultFieldNames = {
    TimeStart : "TimeStart",
    Duration: "Duration",
    MediaTypes: "MediaTypes",
    SourceType: "SourceType",
    Direction: "Direction",
    ParticipantsType: "ParticipantsType"
} as const;


export const EdmTypes = {
  String: "Edm.String",
  DateTimeOffset: "Edm.DateTimeOffset",
  StringCollection: "Collection(Edm.String)",
  Duration: "Edm.Duration",
  Int32: "Edm.Int32",
  GeographyPointCollection: "Collection(Edm.GeographyPoint)",
  Int64: "Edm.Int64",
  Double: "Edm.Double"
} as const;

export type EdmType = typeof EdmTypes[keyof typeof EdmTypes];

  
export interface SystemSettings {
    displayName: string;
    type: EdmType;
    isFilterable: boolean;
    isFacetable: boolean;
    isSortable: boolean;
    filterClause: string;
    isSearchable: boolean;
    supportSuggestions: boolean;
}

export interface UserSettings {
    displayName: string;
    showInFacetArea: boolean;
    orderInFacetArea: number;
    showInDetailsPane: boolean;
    orderInDetailsPane: number;
    showInSearchInFieldsSelector: boolean;
}

export interface Field {
    name: string;
    systemSettings: SystemSettings;
    userSettings: UserSettings;
}

export interface FieldConfiguration {
    fields: Field[];
}

export function isTranscriptionField(name: string){
    return name === "SearchableContent/Transcription/Transcription";
}


/**
 * Converts an array of JSON field objects to an array of `Field` objects.
 * Ensures that the `type` property within `systemSettings` is cast to `EdmType`.
 *
 * @param jsonFields - An array of objects representing fields in JSON format.
 * @returns An array of `Field` objects with properly typed `systemSettings`.
 */
export function fieldsFromJsonToFields(jsonFields: any[]): Field[] {
    return jsonFields.map(field => ({
        ...field,
        systemSettings: {
            ...field.systemSettings,
            type: field.systemSettings.type as EdmType
        }
    }));
}